export enum Method {
	GET = "GET",
	POST = "POST",
	PATCH = "PATCH",
	PUT = "PUT",
	DELETE = "DELETE",
	HEAD = "HEAD",
	OPTIONS = "OPTIONS",
	CONNECT = "CONNECT",
	TRACE = "TRACE",
}

export enum UserType {
  Admin = "admin",
	Owner = "owner",
	Manager = "manager",
	Worker = "worker"
}

export enum EventType {
	Equip = "equip",
	Rtu = "rtu"
}

export enum UserAuthGroup {
	Admin = 1, 				 				//관리자 (TheKIE)
	Owner = 2, 				 				//RTU 소유자 (고객)
	Contractor = 3, 	 				//시공업체 담당자
	RtuManufact = 4, 	 				//RTU업체 담당자 (TheKIE)
	SafetyManager = 5, 				//안전관리 담당자
	HostBizOperator = 6, 	  	//주관사업자 (공기업/ 지자체 등의 지원사업주관기관)
	PrivateBizOperator = 7, 	//민간사업자
	Worker = 8,				//현장작업자
	ASManager = 9			//AS 담당자
}

/** 토큰 용도 타입 */
export enum TokenType {
	Access,											//액세스 토큰
	Refresh,										//리프레쉬 토큰
	ChangePass,									//최초 로그인 비밀번호 번경용 토큰
}

export enum PowerLimitKind {
	rawlastmode = "rawlastmode",
	rawlastratio = "rawlastratio",
	setting = "setting"
}

export enum CompanyKind {
	PV = "pv",
	SolarHeat = "solarheat",	
	GeoHeat = "geoheat",	
	Fuel = "fuel",	
	WF = "wf",
	ESS = "ess",
	Rtu = "rtu",
	Safety = "safety",	
	PublicBiz = "publicbiz",		
	PrivateBiz = "privatebiz",		
}

export enum CompanyGroupKind {
	Equip = "equip", //설비시공업체
	Work = "work",    //현장설치업체
	Public = "public", //주관사업자
	Private = "private", //민간사업자
	Rtu = "rtu" //모니터링업체
}

export enum CustomHeaderKeys {
	UserHeader = "user-header",	
}

export enum TermType {
	Service = "SERVICE",
	Privacy = "PRIVACY",
}

export enum TermStatus {
	Active = "Active",
	Inactive = "Inactive",
}

export enum AccountStatusType {
	PIN_AUTH = "pinAuth",
	ACTIVE = "active",
	LOCK = "lock",
	LEAVE = "leave",
	HOLD = "hold"
}

export enum AccountStatus {
	ACTIVE = "active",
	LOCK = "lock",
	LEAVE = "leave",
	HOLD = "hold"
}

export enum ConnKind {
	Mobile = "mobile",
	PC = "pc",
}

export enum LoginKind {
	Login = "login",
	Logout = "logout",
}

export enum LoginResult {
	Fail = "fail",
	Success = "success",
}

export enum Result {
	Success = "success",
	Fail = "fail",
}

export enum PinType {
	SingUp,
	ResetPass,
}

export enum UseYn {
	Y = "Y",
	N = "N",
}

export enum TokenType {
	BEARER = "Bearer",
}

export enum DateUnit {
	Day = "days",
	Month = "months",
	Year = "years",
	Hour = "hours",
	Minute = "minutes",
	Second = "seconds",
	Date = "date",
}

export enum DateFormatKind {
	YY = "YY",
	YYYY = "YYYY",
	YYYY_MM = "YYYY-MM",
	YYYY_MM_DD = "YYYY-MM-DD",
	YYYY_MM_DD_HH = "YYYY-MM-DD HH",
	YYYY_MM_DD_HH_mm = "YYYY-MM-DD HH:mm",
	YYYY_MM_DD_HH_mm_ss = "YYYY-MM-DD HH:mm:ss",
	YYYY_MM_DD_HH_00_00 = "YYYY-MM-DD HH:00:00",
	YYYY_MM_DD_00_00_00 = "YYYY-MM-DD 00:00:00",
	YYYYMMDDHHmmss = "YYYYMMDDHHmmss",
	YYYY_MM_DD_HH_mm_ss_underbar = "YYYY_MM_DD_HH_mm_ss",
}

// export enum EngSystemCompType {
//   Module,
//   Inverter,
//   Collector,
//   DiffController
// }

export enum DistributionKind {
	SinglePhase,
	ThreePhase,
}

export enum EngSource {
	PV = "10",
	SolarHeat = "20",
	Geothermal = "30",
	WF = "40",
	FuelCell = "60",
	ESS = "70",
}

export enum EquipType {
	SingPhasePV = "11",
	ThreePhasePV = "12",
	ForcedSolarheat = "21",
	NaturalSolarheat = "22"
}

export enum CompType {
	PV_INVERTER = "10",
	PV_MODULE = "11",
	SolarHeat_Controller = "20",
	SolarHeat_Hmeter = "21",
	SolarHeat_WaterHeater = "22",
	SolarHeat_Collector = "23",
	Geo_HeatPump = "30",
	Geo_HwMeter = "31",
	Geo_HcMeter = "31",
	Geo_KWH = "32",
	Geo_Bentonite = "33"
}

export enum SearchDateType {
	Hourly,
	Daily,
	Monthly,
}

export enum MapSearchType {
	OwnerName = "O",
	EquipCompanyName = "E",
	MonitoringCompanyName = "M",
	SafetyCompanyName = "S",
	BizCompanyName = "B",
}

export enum ChartValueType {
	Prod = "prod", //발전량
	Eff = "eff", //발전효율
	Prev = "prev", //전일 발전량
	Predict = "predict", //예측 발전량
}

export enum ChartValueTypeName {
	Prod = "발전량", //발전량
	Eff = "발전효율", //발전효율
	Prev = "전일 발전량", //전일 발전량
	Predict = "예측 발전량", //예측 발전량
}

// export enum OpStatusType {
//   PV = "10",
// }

export enum WeatherConditionType {
	Unknown, //알수 없음
	Clear = 1, //맑음
	Atmosphere_Fog, //대기중 안개
	Atmosphere_Sand, //대기중 모래
	Atmosphere_Tornado, //강풍
	Clouds_100 = 4, //구릅 100
	Clouds_25 = 3, //구름 25
	Drizzle, //이슬비
	Rain = 5, //비
	Snow = 6, //눈
	Thunderstorm, //천둥번개
}

export enum SigninHeaderKind {
	UserDeviceId = "userdeviceid",
	AppId = "appid",
	AppVer = "appver",
	PushRegId = "pushregid",
}

export enum EquipEventStatusKind {
	All = "all",							//전체 (장애 + 조치)
	Failure = "failure",			//장애
	FailOver = "failover",		//조치 - (정상)
}

export enum AlarmType {
	All = "all",							//전체
	Equip = "equip",						//설비
	Etc = "etc",							//기타
}

export enum FailOverStatus {
	Confirmed = "confirmed",
	Processing = "processing",
	Completed = "completed",	
}

export enum EventProcessKind {		
	All,
	Occur,
	Confirmed,
	Processing,
	Completed
}

export enum PushMessageType {	
	EquipFault = "10",			//설비 고장
	EquipFailover = "11",		//설비 조치
	RtuFault = "20",				//RTU 고장
	RtuFailover = "21",			//RTU 조치
	OwnerReport = "30",			//설치자 리포트
	Qna = "70",							//Qna 답글용	
	AD = "80",							//광고
	Notice = "90",					//공지사항	
}

export enum PushAction {
	NoAction = "10",
	MoveWebPage = "20",
	MoveAppPage = "30",
}

export enum EquipFaultStatus {
	Normal = "normal",
	Fault = "fault",
	Down = "down",
}


export enum pvRawDataType {
	"PV 전압" = "dc_inputv",
	"PV 전류" = "dc_inputa",
	"PV 출력" = "dc_input_power",
	"출력 전압(V)" = "ac_gridv",
	"출력 전류(A)" = "ac_grida",
	"계통 R상(RS선간) 전압" = "ac_gridvr",
	"계통 S상(ST선간) 전압" = "ac_gridvs",
	"계통 T상(TR선간) 전압" = "ac_gridvt",
	"계통R상 전류" = "ac_gridar",
	"계통S상 전류" = "ac_gridas",
	"계통T상 전류" = "ac_gridat",
	"현재 출력" = "ac_grid_power",
	"역률" = "pf",
	"주파수" = "freq",
	"누적발전량" = "totalProdWH",
	"고장 여부" = "faultStatus",
}


export enum pvRawDataTypeSingle {
	"PV 전압" = "dc_inputv",
	"PV 전류" = "dc_inputa",
	"PV 출력" = "dc_input_power",
	"출력 전압(V)" = "ac_gridv",
	"출력 전류(A)" = "ac_grida",
	"현재 출력" = "ac_grid_power",
	"역률" = "pf",
	"주파수" = "freq",
	"누적발전량" = "totalProdWH",
	"고장 여부" = "faultStatus",
}


export enum pvRawDataTypeThree {
	"PV 전압" = "dc_inputv",
	"PV 전류" = "dc_inputa",
	"PV 출력" = "dc_input_power",
	"계통 R상(RS선간) 전압" = "ac_gridvr",
	"계통 S상(ST선간) 전압" = "ac_gridvs",
	"계통 T상(TR선간) 전압" = "ac_gridvt",
	"계통R상 전류" = "ac_gridar",
	"계통S상 전류" = "ac_gridas",
	"계통T상 전류" = "ac_gridat",
	"현재 출력" = "ac_grid_power",
	"역률" = "pf",
	"주파수" = "freq",
	"누적발전량" = "totalProdWH",
	"고장 여부" = "faultStatus",
}

export enum geoRawDataType {
	"전압" = "inputv",
	"전류" = "inputa",
	"출력" = "input_power",
	"히트펌프-열생산량" = "hp_prod",
	"히트펌프-누적생산량" = "hp_total_prod_kwh",
	"히트펌프-누적전력사용량" = "hp_total_usage_kwh",
	"히트펌프-상태값" = "hp_status",
	"히트펌프-지열수 입구 온도" = "hp_geowater_ent_temp",
	"히트펌프-지열수 출구 온도" = "hp_getwater_exit_temp",
	"히트펌프-냉난방 입구 온도" = "hp_hc_ent_temp",
	"히트펌프-냉난방 출구 온도" = "hp_hc_exit_temp",
	"히트펌프-냉온수 유량" = "hp_chwater_flow",
	"부하측-입구온도" = "load_ent_temp",
	"부하측-출구온도" = "load_exit_temp",
	"부하측-사용유량값" = "load_usageflow",
	"부하측-누적사용열량값" = "load_total_usagecal",
	"축열조-급수온도" = "htank_watersupply_temp",
	"축열조-급탕온도" = "htank_hwatersupply_temp",
	"축열조-사용유량값" = "htank_usageflow",
	"축열조-누적사용열량값" = "htank_total_usagecal",
	"고장 여부" = "faultStatus",
}

export enum solarRawDataType {
	"집열기 입구 온도" = "collectorEntranceTemp",
	"집열기 출구 온도" = "collectorExitTemp",
	"축열조 상부 온도" = "htank_top_temp",
	"축열조 하부 온도" = "htank_bottom_temp",
	"유량값" = "flowRate",
	"누적생산량" = "totalProdKCAL",
	"급수 배관 온도" = "waterPipeTemp",
	"급탕 배관 온도" = "hwaterPipeTemp",
	"소비 유량값" = "consumptionFlow",
	"소비 누적사용열량" = "totalUsageKCAL",
	"고장 여부" = "faultStatus",
}

export enum equipExcelColumn {
	'cid' = 'cid',
	'사용자ID(RemsID)' = 'userId',
	'사이트 명칭' = 'ownerName',
	'에너지원' = 'engSource',
	'에너지원 세부 유형' = 'equipType',
	'설비 명칭' = 'equipName',
	'인증키' = 'authorization',
	'설비 주소' = 'equipAddr',
	'설비 상세주소' = 'equipDetailAddr',
	'읍면동 코드' = 'dongCode',
	'위도' = 'latitude',
	'경도' = 'longitude',
	'사업 구분 코드명' = 'prjKindName',
	'사업 구분 코드' = 'prjKind',
	'사업 연도' = 'prjRegYear',
	'RTU ID' = 'rtuId',
	'RTU 접속 포트 번호' = 'multi',
	'설비 시공 업체명' = 'equipCompName',
	'설비 시공 업체 일련번호' = 'equipCompSeq',
	'설비 시공 업체 담당자 일련번호' = 'equipCompManagerSeq',
	'설비 시공 업체 담당자 지정일' = 'equipMngSetDate',
	'안전관리 업체명' = 'safetyCompName',
	'안전관리 업체 일련번호' = 'safetyCompSeq',
	'안전관리 업체 담당자 일련번호' = 'safetyCompManagerSeq',
	'안전관리 업체 담당자 지정일' = 'safetyMngSetDate',
	'모니터링 업체명' = 'monitoringCompName',
	'모니터링 업체 일련번호' = 'monitoringCompSeq',
	'모니터링 업체 담당자 일련번호' = 'monitoringCompManagerSeq',
	'모니터링 업체 담당자 지정일' = 'monitoringMngSetDate',
	'RTU 설치및관리 업체명' = 'rtuMngCompName',
	'RTU 설치및관리 업체 일련번호' = 'rtuMngCompSeq',
	'RTU 설치및관리 업체 담당자 일련번호' = 'rtuMngCompManagerSeq',
	'모니터링 시작일시' = 'moniStartDate',
	'설비상태' = 'equipStatus',
	'설비 상태 이상코드' = 'equipStatusError',
	'설비 상태 변경 일시' = 'equipStatusDate',
	'설비 고장여부 상태' = 'equipFaultStatus',
	'건물용도 코드명' = 'buildingUsageName',
	'건물용도' = 'buildingUsage',
	'설치계획번호' = 'installPlanNumber',
	'설치확인관리번호' = 'installConfirmMngNumber',
	'비고' = 'rmk',
	'사업자명' = 'bizName',
	'사업자 일련번호' = 'bizSeq',
	'사업자 담당자 일련번호' = 'bizManagerSeq',
	'사업자 담당자 지정일' = 'bizMngSetDate',
	'설비회사 비고' = 'equipCompRMK',
	'추적시스템' = 'moduleTracking',
	'계통 접속' = 'gridConnection',
	'A/S 만료일' = 'asExpirationDate',
	'시공일시' = 'constructionDate',
	'설치 확인일' = 'constructionConfirmDate',
	'사용전검사일' = 'beforeOpDate',
	'고장여부데이터 예외 처리' = 'isExceptionFaultStatus',
}

export enum ownerExcelColumn {
	'사용자ID(RemsID)' = 'userId',
	'설치자명' = 'ownerName',
	'설치자 주소' = 'ownerAddr',
	'설치자 상세주소' = 'ownerDetailAddr',
	'읍면동 코드' = 'dongCode',
	'요금제 코드명' = 'usagePlanName',
	'요금제' = 'usagePlan',
	'한전ID' = 'kepcoId',
	'이메일' = 'email',
	'전화번호' = 'phone',
	'휴대폰번호' = 'mobile',
	'SMS 수신여부' = 'isSMSSend',
	'이메일 수신여부' = 'isEmailSend',
	'권한그룹 일련번호' = 'authGroupSeq',
	'계정 상태' = 'accountStatus',
	'계약 주체' = 'contractCompany',
	'계약 유형 코드명' = 'contractKindName',
	'계약 유형' = 'contractKind',
	'육지/제주' = 'area',
	'REC 단가' = 'recUnitPrice',
	'REC 가중치' = 'recWeight',
	'계약시작일' = 'contractStartDate',
	'계약종료일' = 'contractEndDate',
	'상업운전일' = 'commercialStartDate',
}

export enum asOwnerExcelColumn {
	'사용자ID(RemsID)' = 'asOwnerRemsId',
	'설치자명' = 'ownerName',
	'설치자 주소' = 'ownerAddr',
	'설치자 상세주소' = 'ownerDetailAddr',
	'읍면동 코드' = 'dongCode',
	'요금제 코드명' = 'usagePlanName',
	'요금제' = 'usagePlan',
	'한전ID' = 'kepcoId',
	'이메일' = 'email',
	'전화번호' = 'phone',
	'휴대폰번호' = 'mobile',
	'SMS 수신여부' = 'isSMSSend',
	'이메일 수신여부' = 'isEmailSend',
}

export enum asEquipExcelColumn {
	'사용자ID(RemsID)' = 'asOwnerRemsId',
	'cid' = 'cid',
	'에너지원' = 'engSource',
	'에너지원 세부 유형' = 'equipType',
	'인증키' = 'authorization',
	'설비 주소' = 'equipAddr',
	'설비 상세주소' = 'equipDetailAddr',
	'읍면동 코드' = 'dongCode',
	'위도' = 'latitude',
	'경도' = 'longitude',
	'사업 구분 코드명' = 'prjKindName',
	'사업 구분 코드' = 'prjKind',
	'사업 연도' = 'prjRegYear',
	'건물용도 코드명' = 'buildingUsageName',
	'건물용도' = 'buildingUsage',
	'설치계획번호' = 'installPlanNumber',
	'설치확인관리번호' = 'installConfirmMngNumber',
	'RTU 접속 포트 번호' = 'multi',
	"설비 시공 업체명" = 'equipCompName',
	'설비 시공 업체 일련번호' = 'equipCompSeq',
	'설비 시공 업체 담당자 일련번호' = 'equipCompManagerSeq',
	'사업자명' = 'bizName',
	'사업자 일련번호' = 'bizSeq',
	'사업자 담당자 일련번호' = 'bizManagerSeq',
	'사업자 담당자 지정일' = 'bizMngSetDate',
	'비고' = 'rmk',
	'추적시스템' = 'moduleTracking',
	'계통 접속' = 'gridConnection',
	'A/S 만료일' = 'asExpirationDate',
	'시공일시' = 'constructionDate',
	'설치 확인일' = 'constructionConfirmDate',
	'사용전검사일' = 'beforeOpDate',
}

export enum equipPVSExcelColumn {
	'모듈 설치 방식' = 'moduleInstallType',
	'모듈 결정 분류' = 'moduleType',
	'모듈 당 용량(W)' = 'moduleCapacity',
	'모듈 총 용량' = 'moduleTotalCapacity',
	'모듈 제조사명' = 'moduleCompany',
	'모듈 모델 코드' = 'moduleModelCode',
	'모듈 모델명' = 'moduleModelName',
	'모듈 방위각' = 'moduleAzimuth',
	'모듈 경사각' = 'moduleAngle',
	'모듈 직렬개수' = 'moduleSerialCnt',
	'모듈 병렬개수' = 'moduleParallelCnt',
	'인버터 제조사명' = 'pviCompany',
	'인버터 모델 코드' = 'pviModelCode',
	'인버터 모델명' = 'pviModelName',
	'인버터 용량' = 'pviCapacity',
	'인버터 위상 종류' = 'pviPhase',
}

export enum equipSolarHeatForcedExcelColumn {
	'현재 사용 열원' = 'usageEngSource',
	'집열기 설치 방식' = 'collectorInstallType',
	'집열기 종류' = 'collectorKind',
	'집열기 면적' = 'collectorArea',
	'집열기 제조사명' = 'collectorCompany',
	'집열기 모델코드' = 'collectorModelCode',
	'집열기 모델명' = 'collectorModelName',
	'집열기 직렬개수' = 'collectorSerialCnt',
	'집열기 병렬개수' = 'collectorParallelCnt',
	'집열기 매수' = 'collectorCnt',
	'차온제어기 제조사명' = 'controllerCompany',
	'차온제어기 모델 코드' = 'controllerModelCode',
	'차온제어기 모델명' = 'controllerModelName',
	'부하측 열량계 제조사명' = 'hMeterCompany',
	'부하측 열량계 모델 코드' = 'hMeterModelCode',
	'부하측 열량계 모델명' = 'hMeterModelName',
	'방위각' = 'azimuth',
	'경사각' = 'angle',
	'열매체 펌프 유형' = 'hpumpType',
	'열매체 펌프 유량[LPM]' = 'hpumpFlow',
	'열매체 펌프 양정[m]' = 'hpumpHead',
	'열매체 보충 펌프 유형' = 'hSubpumpType',
	'열매체 보충 펌프 유량[LPM]' = 'hSubpumpFlow',
	'열매체 보충 펌프 양정[m]' = 'hSubpumpHead',
	'온수 순환 펌프 유형' = 'circulatorpumpType',
	'온수 순환 펌프 유량[LPM]' = 'circulatorpumpFlow',
	'온수 순환 펌프 양정[m]' = 'circulatorpumpHead',
	'유속[m/s]' = 'flowSpeed',
	'운전압력[bar]' = 'opPressure',
	'배관관경[A]' = 'pipeDiameter',
	'축열탱크 용량[l]' = 'storageCapacity',
	'축열탱크 재질' = 'storageMaterial',
	'보증기간' = 'warranty',
}

export enum equipSolarHeatNaturalExcelColumn {
	'현재 사용 열원' = 'usageEngSource',
	'집열기 설치 방식' = 'collectorInstallType',
	'집열기 종류' = 'collectorKind',
	'집열기 면적' = 'collectorArea',
	'온수기 제조사명' = 'collectorCompany',
	'온수기 모델 코드' = 'collectorModelCode',
	'온수기 모델명' = 'collectorModelName',
	'집열기 매수' = 'collectorCnt',
	'차온제어기 제조사명' = 'controllerCompany',
	'차온제어기 모델 코드' = 'controllerModelCode',
	'차온제어기 모델명' = 'controllerModelName',
	'열량계 제조사명' = 'hMeterCompany',
	'열량계 모델 코드' = 'hMeterModelCode',
	'열량계 모델명' = 'hMeterModelName',
	'방위각' = 'azimuth',
	'경사각' = 'angle',
	'축열탱크 용량[l]' = 'storageCapacity',
	'축열탱크 재질' = 'storageMaterial',
	'보증기간' = 'warranty',
}

export enum equipGeoExcelColumn {
	'시스템방식' = 'geoSysType',
	'시스템구분' = 'geoSysKind',
	'히트펌프-용량' = 'hpCapacity',
	'히트펌프 제조사명' = 'hpCompany',
	'히트펌프 모델 코드' = 'hpModelCode',
	'히트펌프 모델명' = 'hpModelName',
	'급탕 열량계 제조사명' = 'hwMeterCompany',
	'급탕 열량계 모델 코드' = 'hwMeterModelCode',
	'급탕 열량계 모델명' = 'hwMeterModelName',
	'냉난방측 열량계 제조사명' = 'hcMeterCompany',
	'냉난방측 열량계 모델 코드' = 'hcMeterModelCode',
	'냉난방측 열량계 모델명' = 'hcMeterModelName',
	'전력량계 제조사' = 'KWHCompany',
	'전력량계 모델 코드' = 'KWHModelCode',
	'전력량계 모델명' = 'KWHModelName',
	'벤토나이트 제조사' = 'bentoniteCompany',
	'벤토나이트 모델 코드' = 'bentoniteModelCode',
	'벤토나이트 모델명' = 'bentoniteModelName',
	'냉온수 유량' = 'chWaterFlow',
	'지열수 유량' = 'geoWaterFLow',
	'천공깊이(m)' = 'boringDeep',
	'천공개수' = 'boringCount',
}

export enum bpmReqExcelColumn {
	'접수일자' = 'reqDate',
	'신청자명' = 'reqName',
	'생년월일' = 'birthDate',
	'신청자 연락처' = 'reqMobile',
	'설치장소 도로명 주소' = 'siteRoadAddr',
	'설치장소 지번 주소' = 'siteJibunAddr',
	'에너지원' = 'engSource',
	'시설구분' = 'buildingKind',
	'사업구분' = 'prjKind',
	'사업연도' = 'prjRegYear',
	'신축여부' = 'isNew',
	'건축물대장' = 'buildingRegister',
	'접수(메모)' = 'memo',
	'신청결과' = 'bpmReqStatus',
	'현장조사결과' = 'siteCheck',
	'현장조사기업' = 'siteSurveyCompany',
	'현장조사기업담당자명' = 'siteSurveyCompanyManagerName',
	'현장조사일자' = 'siteSurveyDate',
	'현장조사 비고' = 'rmk',
	'수요자사업신청서' = 'ownerApplication',
	'본인서명사실확인서' = 'signatureVerificationCertification',
	'현장관리결과' = 'siteManageResult',
	'시공기업' = 'constructionCompany',
	'시공기업담당자' = 'constructionCompanyManagerName',
	'현장관리 비고' = 'siteManageRmk',
	'BPM서류' = 'bpmDocument',
	'한전 계약자 및 토지 소유자 확인' = 'isKepcoLandOwnerVerified',
}

export enum NativeAction {
	PermissionCheckBio = "PermissionCheckBio",
	PermissionCheckLocation = "PermissionCheckLocation",
	PermissionCheckCamera = "PermissionCheckCamera",
	PermissionCheckMedia = "PermissionCheckMedia",
	EnableBio = "EnableBio",
	DisableBio = "DisableBio",
	HapticClick = "HapticClick",
	HapticLong = "HapticLong",
	DontSeeIntro = "DontSeeIntro",
	Login = "Login",
	Dev = "Dev",	
}

export enum PermissionType {
	Camera = "Camera",
	Media = "Media",
}

export enum PermissionStatus {
	Unknown = 0,
	Denied = 1,
	Disabled = 2,
	Granted = 3,
	Restricted = 4,
	Limited = 5,
}

export enum IsYnNum {
	No = "0",
	Yes = "1",
}

export enum OpStatus {
	Down = "down",
	Fault = "fault",
	Normal = "normal",
	Preparing = "preparing",
	Warning = "warning",
}

export enum EquipRtuKind {
	Equip = "equip",
	Rtu = "rtu",
}

export enum PushMsgSendStatus {
	Ready = "00",
	Completed = "10",
}

export enum PushMsgSendResult {
	Success = "10",
	Fail = "20"
}

export enum AreaKind {
	Country = "country",
	City = "city",
	Sigungu = "sigungu",
	Dong = "dong"
}

export enum groupLevel {
	sigungu = "sigungu",
	dong = "dong"
}

/** TOC 공통 검색어 입력 타입  */
export enum SearchKind {
	Cid = "10",
	OwnerName = "20",
	SiteName = "30",
	MngName = "40",
	OwnerId = "50",
	CompanyName = "60",
	EquipAddr = "70",
	OwnerAddr = "80",
	WorkerName = "90",
	ReqName = "100",
	NoticeAll = "110",
	NoticeTitle = "120",
	RtuId = "130",
	RtuModel = "140",
	ModemPhone = "150",
	Memo = "160",
	ALL = "170"
}

export enum WorkReqStatus {
	Request = "request",
	Receipt = "receipt",
	Working = "working",
	Worked = "worked",
	Complete = "complete"
}

export enum OnmKind {
	Rtu = "rtu",
	Eq = "eq"
}

export enum ChgWorkStatus {
	Check = "check",
	Checked = "checked",
	Work = "work"
}

export enum WorkStatus {
	Connected = "connected",
	Check = "check",
	Checked = "checked",
	Work = "work",
	WorkTemp = "work_temp",
	Worked = "worked"
}

export enum WorkInstallType {
	New = "new",
	ChgRtu = "chg_rtu",
	ChgOwner = "chg_owner"
}

export enum ChangesReqKind {
	ChgRtu = "chg_rtu",
	ChgOwner = "chg_owner",
}

export enum WorkReqKind {
	New = "new",
	ChgRtu = "chg_rtu",
	ChgOwner = "chg_owner",
	NewCmpl = "new_cmpl",
	CrtuCmpl = "crtu_cmpl",
	CowCmpl = "cow_cmpl",
	RtuCmpl = "rtu_cmpl",
	EqCmpl = "eq_cmpl",
	Onm = "onm",
}

export enum ASStatus {
	Work = "work",
	WorkTemp = "workTemp",
	Worked = "worked"
}

export enum ASReqKind {
	as = "as"
}

export enum RequestKind {
	WorkTemp = "work_temp",
	Worked = "worked",
	Complement = "complement",
	Complete = "complete"
}

export enum WorkRequestKind {
	Requests = "requests",
	Works = "works",
	ReqManages = "reqManages"
}

export enum WorkRequestStatus {
	Not = "not",
	Worked = "worked",
	Work = "work",
	WorkTemp = "work_temp",
	Complete = "complete",
	Etc = "etc"
}

export enum WorkType {
	New = "new",
	ChgRtu = "chg_rtu",
	ChgOwner = "chg_owner",
	RtuOnm = "rtu_onm",
	EqOnm = "eq_onm",
	NewCmpl = "new_cmpl",
	CrtuCmpl = "crtu_cmpl",
	CowCmpl = "cow_cmpl",
	RtuCmpl = "rtu_cmpl",
	EqCmpl = "eq_cmpl",
}

export enum rtuStatus {
	ready = "ready",
	installed = "installed",
	live = "live"
}

export enum equipStatus {
	preparing = "preparing",
	normal = "normal",
	warning = "warning",
	fault = "fault",
	down = "down"
}

export enum equipStatusError {
	preparing = "운영준비중",
	normal = "정상",
	warning = "경고",
	fault = "오류",
	down1 = "통신에러",
	down2 = "데이터미수신"
}

export enum isField {
	site = "site",
	remote = "remote"
}

/** TOC 검색바 있는 화면 종류 **/
export enum tocSearchBarKind {
	//설비정보
	eqMap = "equipMap",						//설비정보 > 발전설비현황
	//운영정보
	eqList = "equipList",					//운영정보 > 발전설비정보   AS 신청 관리
	eqSite = "equipSite",					//운영정보 > 발전사이트정보
	eqKWH = "equipKWH",						//운영정보 > 발전량정보
	//통계분석
	ownerProd = "ownerProd",				//통계분석 > 설치자별 생산량
	ownerCompare = "ownerCompare",	//통계분석 > 설치자간 비교
	areaCompare = "areaCompare",		//통계분석 > 운영지역간 비교
	//이벤트관리
	eqEvent = "equipEvent",					//이벤트관리 > 이벤트처리정보
	//AS 신청 관리 목록
	eqASList = "equipASRequest", // AS 신청 목록 관리
	eqASCompanys = "equipASCompanys", // AS company 관리
	asOwnerList = "asOwnerList", // AS 설치자 관리
	asEquipList = "asEquipList", // AS 설비 관리
	bpmList = "bpmList", // BPM 목록 관리
	bpmReqList = "bpmReqList", // BPM req 목록 관리
	rtuInfoList = "rtuInfoList", // RTU 정보 관리
	rtuInstallList = "rtuInstallList", // RTU 현장 설치 관리
	workReqManage = "workReqManage", // 신규작업요청 관리
	rtuInstallReport = "rtuInstallReport", // RTU 준공보고서
}

export enum parameterName {
  engSource = '에너지원',
  prjKind = '사업구분',
  prjRegYear = '사업연도',
  rtuStatus = 'RTU 상태',
  rtuModel = 'RTU 모델',
  firmwareVersion = '펌웨어 버전',
  equipStatus = '설비상태',
  eqType = '시설유형',
  buildingUsage = '건물종류',
  accountStatus = '회원상태',
  tariff = '요금제',
  eventType = '이벤트종류',
  asStatus = 'AS 상태',
  asStartDate = "AS 수행 연도",
  bpmReqStatus = '접수 상태',
  bpmCompanyName = '참여기업',
}

export enum ExcelKind {
	ownerList = 'ownerlist',
	pvList = 'pvlist',
	asOwnerList = 'asownerlist',
	owner = '설치자',
	pv = '태양광',
	solarheatForced = '태양열 강제',
	solarheatNatural = '태양열 자연',
	geo = '지열'
}

export enum ExcelOwnerKind {
	energyAgency = '공단계정',
	self = '자체계정'
}

export enum SelectAllKind {
	Select = 'select',
	All = 'all'
}

export enum RtuOpKind {
	KEA_REMS = "10" //한국 에너지공단 REMS로 데이터 전송
}

export enum RainType {
	Dry = "0",
	Rain = "1",
	RainSnow = "2",
	Snow = "3",
	Shower = "4"
}

export enum CloudType {
	Clear = "1",
	Partly = "3",
	Cloudy = "4",
}

/** BPM 신청결과 (codes.bpmReqStatus) */
export enum BpmReqStatus {
	Receipt = "receipt",
	RcpDefer = "rcpDefer",
	AddReceipt = "addReceipt",
	AddRcpDef = "addRcpDef",
	RcpCancel = "rcpCancel",
}

/** BPM 현장조사결과 (codes.bpmSiteCheck) */
export enum BpmSiteCheck {
	Select = "select",
	SelectDef = "selectDef",
	ReqCancel = "cancel",
	ReqDefer = "defer",
	BBiz = "bBiz",
}

/** BPM 현장관리결과 (codes.bpmManageStatus) — bpmReqStatus와 code 충돌 방지용 별도 prefix */
export enum BpmManageStatus {
	MngSelect = "mngSelect",
	MngDefer = "mngDefer",
	MngCancel = "mngCancel",
	InProgress = "inProgress",
	Complete = "complete",
}

const BPM_MANAGE_STATUS_CODE_SET = new Set<string>(Object.values(BpmManageStatus));
const BPM_SITE_CHECK_CODE_SET = new Set<string>(Object.values(BpmSiteCheck));

/** 현장관리결과(siteManageResult) 코드 여부 */
export function isBpmManageStatusCode(code: string | null | undefined): boolean {
	return code != null && BPM_MANAGE_STATUS_CODE_SET.has(code);
}

/** 현장조사결과(siteCheck) 코드 여부 */
export function isBpmSiteCheckCode(code: string | null | undefined): boolean {
	return code != null && BPM_SITE_CHECK_CODE_SET.has(code);
}

export enum ValueCardMap {
	"금일 총 생산량" = "todayProdKWH",
	"총 생산량" = "totalProdKWH"
}

export enum WidgetParamsAuto{
	"startDate",
	"endDate",
	"cid",
	"engSource",
	"siteName",
	"rtuId",
}

export enum WidgetParamsManual{
	"searchDate",
	"searchDateType",
	"ownerSeq",
	"eventType"
}

// EXTVIEW: 외함전경사진, INTVIEW: 내함전경사진, FRONTRTU: 전면 RTU 사진

export enum AttachOrderType {
	EXTVIEW = 1,
	INTVIEW = 2,
	FRONTRTU = 3,
}

/** 융복합지원 사업 prjKind 코드 */
export const PRJ_KIND_FUSION_SUPPORT = '33001';

/** 사업비 산출 시트 구분 */
export enum CostEstimateSheetKind {
	Summary = 'summary',
	ByCompany = 'by_company',
}

/** 사업비 산출 입력 필드 상한 */
export const COST_ESTIMATE_FIELD_MAX = {
	siteCount: 1000,
	capacity: 100_000,
	amount: 100_000_000,
	totalCost: 100_000_000,
	govCost: 100_000_000,
	localCost: 100_000_000,
	privateCost: 100_000_000,
} as const;
